var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrueWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3657 0.734315C11.6781 1.04673 11.6781 1.55327 11.3657 1.86569L4.96571 8.26569C4.65329 8.5781 4.14676 8.5781 3.83434 8.26569L0.634339 5.06569C0.32192 4.75327 0.32192 4.24673 0.634339 3.93431C0.946758 3.6219 1.45329 3.6219 1.76571 3.93431L4.40002 6.56863L10.2343 0.734315C10.5468 0.421895 11.0533 0.421895 11.3657 0.734315Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrueWhite);
export default __webpack_public_path__ + "static/media/trueWhite.d157269be82a7593f92ddb8990ea9065.svg";
export { ForwardRef as ReactComponent };